import { get } from '@/utils/request'
import type { DashboardStats } from '@/types'

/** 项目统计（工作台按当前项目统计） */
export const getStats = (projectId: number) =>
  get<DashboardStats>('/dashboard/stats', { project_id: projectId })

/** 最近测试报告 */
export const getRecentReports = (limit = 10, projectId?: number) =>
  get<RecentReport[]>('/dashboard/recent-reports', { limit, project_id: projectId })

/** 最近报告（工作台展示用） */
export interface RecentReport {
  id: number
  name: string
  /** 任务类型: 1=接口场景测试/2=UI测试 */
  task_type: number
  /** 运行结果: 1=成功/2=失败 */
  run_result: number
  pass_rate: number
  duration_ms: number
  run_time: string | null
}

/** 用例增长趋势单日数据 */
export interface CaseTrendPoint {
  date: string
  /** 功能用例新增数 */
  functional: number
  /** 接口场景用例新增数 */
  scenario: number
  /** UI 用例新增数 */
  ui: number
}

/** 用例增长趋势（三条线） */
export const getCaseTrend = (days = 30, projectId?: number) =>
  get<CaseTrendPoint[]>('/dashboard/case-trend', { days, project_id: projectId })
